import React from "react";
import { HomeFooterUI } from "./HomeFooterUI";

function HomeFooter() {
    return (
        <HomeFooterUI />
    );
}

export { HomeFooter }
